import SystemFieldProto from '../../proto/system-field-proto';
import Moment from 'moment';
import AggregateMoment from "../../aggregate/aggregate-moment";
import AggregateMomentComponent from "../components/aggregate-moment";
import normalizeDate from "../../import/normalize/normalize-date";
import FieldDateViewInImport from "../../import/view-in-preview/date-view-in-import";

export default class DateClosedField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.DATE_CLOSED;
    }

    get sortHintMessage() {
        return 'Sort by date closed';
    }

    getCsvValue(item) {
        if (!item.momentClosed) return null;
        return Moment(item.momentClosed).format("YYYY-MM-DD");
    }

    getValue(item) {return item.momentClosed}

    getAggregateClass() {return AggregateMoment}
    getAggregateOptions() {return [
        gd.const.aggregate.type.MIN,
        gd.const.aggregate.type.MAX,
        gd.const.aggregate.type.RANGE
    ]}

    listItemSortFunctions(sort) {
        return {
            functions: [i => i.item.momentClosed ? i.item.momentClosed.unix() : 0], //somehow momentClosed could be undefined
            directions: [sort]
        }
    }

    get AggregateComponent() {return AggregateMomentComponent.bind(null, this.getAggregateOptions())}

    // IMPORT

    normalizeCSVValue(value) {
        return normalizeDate(value);
    }

    getComponentViewInImport() {
        return FieldDateViewInImport;
    }
}
